import type { FaireProductEntity } from "../../entity_types/product";

export const p_3da4dzcjdk: FaireProductEntity = {
  token: "p_3da4dzcjdk",
  type: "product",
  name: "LE GRAND MARMONT",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl: "https://cdn.faire.com/fastly/90e579299401b4945eb5d90f353f12db6e67a6359326f38acaf6f27cfbaf13cb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a6b670e3413e625b9aff143ebd62e0a6c9440cab0dbebd9482907a66b31f3c1c.jpeg",
    "https://cdn.faire.com/fastly/68bbcfab4a4f39a74e254a362b746e4baf2624b2b8d05b5260f423413e9aab47.jpeg",
    "https://cdn.faire.com/fastly/ff381b0b08db778c2a5f4eae8916f89b3fd0cebd069c4b016a5af6255d34c9ec.jpeg"
  ],
  priceDollars: 30,
  description: "Le Grand Marmont, 14 oz of your favorite scent!\n\nNestled in the Hollywood hills amidst lush gardens and hillside bungalows is the iconic Chateau Marmont. Recalling a lingering afternoon spent on the famed garden terrace with top notes of citrus, blackcurrant and rose opening to a seductively dark base of moss, musk, and a hint of leather. Creating a fragrance as compelling as its namesake hotel.\n\nWild rose, lily, white musk, moss, leather\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn. We use lead-free cotton wicks and premium fragrance oils. All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials.\n\n14 ounces (397g), comes in our signature pink box.",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:05:09.424Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
